import React from 'react';
import { 
    LoginFormBlock, 
    InputStyled, 
    FieldWrapper, 
    FieldTitle,
    LoginBtn, 
    LoginDisabledBtn, 
    FormFooter, 
    FormLink, 
    CompanySignupLink,
    ErrorBlock,
    ErrorIcon,
    ErrorMessage 
} from './style'
import warningIcon from 'images/warning.png';
import {Link} from 'react-router-dom'

const LoginForm = ({redirectPath, isValid, onSubmit, onChange, emailError, passwordError}) => {
    return (
        <LoginFormBlock>
            <FieldWrapper>
                <FieldTitle>이메일</FieldTitle>
                <InputStyled type={'email'} onChange={(e)=>{if(onChange)onChange({email:e.target.value});}} placeholder="이메일 주소를 입력해 주세요" />
            {emailError ? (
                <ErrorBlock>
                    <ErrorIcon src={warningIcon}/>
                    <ErrorMessage>{emailError}</ErrorMessage>
                </ErrorBlock>
            ) : null}
            </FieldWrapper>
            <FieldWrapper>
                <FieldTitle>비밀번호</FieldTitle>
                <InputStyled type={`password`} onChange={(e)=>{if(onChange)onChange({password:e.target.value});}} placeholder="*********" />
            {passwordError ? (
                <ErrorBlock>
                    <ErrorIcon src={warningIcon}/>
                    <ErrorMessage>{passwordError}</ErrorMessage>
                </ErrorBlock>
            ) : null}
            </FieldWrapper>
            {
                (isValid)
                ?(<LoginBtn onClick={(e)=>{if(onSubmit)onSubmit();}}>로그인</LoginBtn>)
                :(<LoginDisabledBtn>로그인</LoginDisabledBtn>)
            }
            <FormFooter>
                {
                    (redirectPath)
                    ?(<FormLink to={`/signup?redirect_path=${redirectPath}`}>회원가입</FormLink>)
                    :(<FormLink to={`/signup`}>회원가입</FormLink>)
                }
                <FormLink  to={`/password`}>비밀번호 재설정</FormLink>
            </FormFooter>
            {/* <div>
                {
                    (redirectPath)
                    ?(<CompanySignupLink to={`/signup/company?redirect_path=${redirectPath}`}>기업 회원가입</CompanySignupLink>)
                    :(<CompanySignupLink to={`/signup/company`}>기업 회원가입</CompanySignupLink>)
                }
                
            </div> */}
            {/*<div><FormLink  to={`/social`}>test</FormLink></div>*/}
        </LoginFormBlock>
    );
}

export default LoginForm;